import { createSlice } from "@reduxjs/toolkit";
import { getAdultVerifyLogs } from "./thunk";

export interface IState {
  adultVerifyLogs: any;
  isAdultVerifyLogLoading: boolean;
  isAdultVerifyLogSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  adultVerifyLogs: null,
  isAdultVerifyLogLoading: false,
  isAdultVerifyLogSuccess: false,

  error: {},
};

const AdultVerifyLogSlice = createSlice({
  name: "AdultVerifyLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAdultVerifyLogs.pending, (state: IState, action: any) => {
      state.isAdultVerifyLogLoading = true;
    });
    builder.addCase(getAdultVerifyLogs.fulfilled, (state: IState, action: any) => {
      state.adultVerifyLogs = action.payload.data;
      state.isAdultVerifyLogSuccess = true;
      state.isAdultVerifyLogLoading = false;
    });
    builder.addCase(getAdultVerifyLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isAdultVerifyLogSuccess = false;
      state.isAdultVerifyLogLoading = false;
    });
  },
});

export default AdultVerifyLogSlice.reducer;